import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import isPropValid from '@emotion/is-prop-valid';
import { AppBar, Link, styled, Typography } from '@mui/material';
import { forwardRef } from 'react';
import LensBorder from './lens-border';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NotificationWrapper = styled(AppBar, {
  shouldForwardProp: isPropValid
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  justify-content: ", ";\n  flex-direction: row;\n  position: ", ";\n  z-index: ", ";\n"])), function (p) {
  return p.barColor;
}, function (p) {
  return p.theme.palette.accent.contrastText;
}, function (p) {
  return p.theme.spacing(0.5, 2);
}, function (p) {
  return p.hasTwoLines ? 'space-between' : 'center';
}, function (p) {
  return p.sticky ? 'sticky' : 'inherit';
}, function (p) {
  return p.theme.zIndex.lensBarNotifications;
});
export var ActionLink = styled(Link)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: underline;\n  margin-left: ", ";\n  cursor: pointer;\n  &:hover {\n    text-decoration: none;\n  }\n"])), function (p) {
  return p.theme.palette.accent.contrastText;
}, function (p) {
  return p.theme.spacing(2);
});
export default /*#__PURE__*/forwardRef(function SuccessNotification(_ref, ref) {
  var barColour = _ref.barColour,
      notification = _ref.notification,
      linkAction = _ref.linkAction,
      linkText = _ref.linkText,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive;
  return /*#__PURE__*/_jsxs(NotificationWrapper, {
    ref: ref,
    sticky: isActive,
    barColor: barColour,
    hasTwoLines: isMobile && isActive,
    children: [notification, /*#__PURE__*/_jsx(ActionLink, {
      onClick: linkAction,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        children: linkText
      })
    }), isActive && /*#__PURE__*/_jsx(LensBorder, {})]
  });
});